import { useState, useEffect } from 'react';
import axios from 'axios';

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}job/allJob2`, {
        params: { page, limit }
      });
      setJobs(response.data);
     
      setTotalPages(Math.ceil(response.data.length / limit)); 
    } catch (error) {
      console.error('Error fetching jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [page]);

  const openModal = (job) => {
    setSelectedJob(job);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedJob(null);
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Available Jobs</h2>

      {loading ? (
        <div className="text-center text-gray-600">Loading...</div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {jobs.map((job) => (
              <div
                key={job._id}
                className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-gray-800">{job.jobTitle}</h3>
                <p className="text-gray-600 mt-2">{job.jobSummary}</p>
                <div className="mt-4 space-y-2">
                  <p><span className="font-medium">Company:</span> {job.employer?.companyName || 'N/A'}</p>
                  <p><span className="font-medium">Location:</span> {job.localGovernment}, {job.state}</p>
                  <p><span className="font-medium">Salary:</span> {job.currency} {job.salary}</p>
                  <p><span className="font-medium">Job Type:</span> {job.jobType}</p>
                  <p><span className="font-medium">Work Type:</span> {job.workType}</p>
                  <p><span className="font-medium">Openings:</span> {job.numberOfOpenings}</p>
                </div>
                <button
                  className="mt-4 bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
                  onClick={() => openModal(job)}
                >
                  View More
                </button>
              </div>
            ))}
          </div>

          <div className="mt-8 flex justify-center space-x-4">
            <button
              className="bg-gray-300 text-gray-800 px-4 py-2 rounded disabled:opacity-50"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>
            <span className="text-gray-800">Page {page} of {totalPages}</span>
            <button
              className="bg-gray-300 text-gray-800 px-4 py-2 rounded disabled:opacity-50"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        </>
      )}

      {isModalOpen && selectedJob && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">{selectedJob.jobTitle}</h2>
            <div className="space-y-4">
              <p><span className="font-medium">Job Summary:</span> {selectedJob.jobSummary}</p>
              <p><span className="font-medium">Job Description:</span></p>
              <ul className="list-disc pl-6">
                {selectedJob.jobDescription?.map((desc, index) => (
                  <li key={index}>{desc}</li>
                ))}
              </ul>
              <p><span className="font-medium">Company:</span> {selectedJob.employer?.companyName || 'N/A'}</p>
              <p><span className="font-medium">Location:</span> {selectedJob.localGovernment}, {selectedJob.state}</p>
              <p><span className="font-medium">Salary:</span> {selectedJob.currency} {selectedJob.salary}</p>
              <p><span className="font-medium">Job Type:</span> {selectedJob.jobType}</p>
              <p><span className="font-medium">Work Type:</span> {selectedJob.workType}</p>
              <p><span className="font-medium">Job Function:</span> {selectedJob.jobFunction}</p>
              <p><span className="font-medium">Industry:</span> {selectedJob.industry}</p>
              <p><span className="font-medium">Minimum Qualification:</span> {selectedJob.minimumQualification}</p>
              <p><span className="font-medium">Experience Length:</span> {selectedJob.experienceLength}</p>
              <p><span className="font-medium">Job Level:</span> {selectedJob.jobLevel || 'N/A'}</p>
              <p><span className="font-medium">Open for Students:</span> {selectedJob.openForStudents}</p>
              <p><span className="font-medium">Number of Openings:</span> {selectedJob.numberOfOpenings}</p>
              <p><span className="font-medium">Vacancy Duration:</span> {selectedJob.vacancyDuration}</p>
              <p><span className="font-medium">Contact Email:</span> {selectedJob.contactMail || 'N/A'}</p>
              <p><span className="font-medium">Skills:</span> {selectedJob.jobSkills?.join(', ') || 'None'}</p>
              <p><span className="font-medium">Tags:</span> {selectedJob.jobTag?.join(', ') || 'None'}</p>
              <p><span className="font-medium">Requires Cover Letter:</span> {selectedJob.requireCoverLetter ? 'Yes' : 'No'}</p>
              <p><span className="font-medium">Requires Document Upload:</span> {selectedJob.requiredocumentUpload ? 'Yes' : 'No'}</p>
              <p><span className="font-medium">Validated:</span> {selectedJob.isValidated ? 'Yes' : 'No'}</p>
              <p><span className="font-medium">Starred:</span> {selectedJob.isStarred ? 'Yes' : 'No'}</p>
              <p><span className="font-medium">Number of Applicants:</span> {selectedJob.numberOfApplicant?.length || 0}</p>
            </div>
            <button
              className="mt-6 bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Jobs;